import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './query-client';

const QueryClient: React.FC<{ children: React.ReactNode }> = ({ children }): React.ReactElement => (
	<QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);

export default QueryClient;
